<template>
    <div v-if="current_size !== 'xs'">
        <left_panel_bookings_table_wrapper :bookings="this.bookings" :height_correction="this.height_correction"/>
    </div>
    <div v-else>
        <left_panel_bookings_table_wrapper_xs :bookings="this.bookings" :height_correction="this.height_correction"/>
     </div>
  </template>
  
  <script>

    import mxscreensize from '@/components/js/screensize';
    import left_panel_bookings_table_wrapper_xs from '@/components/dashboard/sections/left_panel_bookings_table_wrapper_xs.vue';
    import left_panel_bookings_table_wrapper from '@/components/dashboard/sections/left_panel_bookings_table_wrapper.vue';

    export default {    
        props: {
            height_correction: Number,
        },    
        mounted() {
            this.load(); 
        },          
        mixins:[mxscreensize],
        components: {
            left_panel_bookings_table_wrapper_xs,
            left_panel_bookings_table_wrapper,
        },
        data() {
            return {
                bookings: [],
            }
        },   
        methods: {       
            load(){
                console.log('(re) load left panel bookings');
                this.$axios
                    .post("ares/json/ares/syst/dashboard/getDayBookingsv1.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getDayBookings"
                        },
                        getDayBookings: {}
                    })
                    .then(res => {
                        res.data.error ? console.log(res.data.error) : this.bookings = res.data.getDayBookings;
                        console.log(this.bookings)
                    })
            },       
       }
    }
  </script>
  
  <style scoped>
  </style>